module.exports = {
	nonmath: {
		st: "$^{\\text{st}}$",
		nd: "$^{\\text{nd}}$",
		rd: "$^{\\text{rd}}$",
		th: "$^{\\text{th}}$",
		or: "\\[ \\read{;; or ;;}{ \\text{— \\bold{\\italic{or}} —}} \\]",
		and: "\\[ \\read{;; and ;;}{ \\text{— \\bold{\\italic{and}} —}} \\]",
		deg: "\u00B0", //Roboto has this
		cents: "\u00A2", //Roboto has this
		times: "$*$",
		div: "$/$",
		hearts: "\\bigger{\\color{cardred}{\u2665}}", //TODO: Not in Roboto
		diamonds: "\\bigger{\\color{cardred}{\u2666}}", //TODO: Not in Roboto
		clubs: "\\bigger{\u2663}", //TODO: Not in Roboto
		spades: "\\bigger{\u2660}", //TODO: Not in Roboto
		checkmark: "\\read{}{\\lizzie{\u00A5}}",
		xmark: "\\read{}{\\lizzie{\u00A3}}",
	},
	math: {
		st: "^{\\text{st}}",
		nd: "^{\\text{nd}}",
		rd: "^{\\text{rd}}",
		th: "^{\\text{th}}",
		deg: "\u00B0",
		cents: "\u00A2",
		times: "*",
		div: "/",
		hearts: "\\bigger{\\color{cardred}{\u2665}}", //TODO: Not in Roboto
		diamonds: "\\bigger{\\color{cardred}{\u2666}}", //TODO: Not in Roboto
		clubs: "\\bigger{\u2663}", //TODO: Not in Roboto
		spades: "\\bigger{\u2660}", //TODO: Not in Roboto
		checkmark: "\\read{}{\\lizzie{\u00A5}}",
		xmark: "\\read{}{\\lizzie{\u00A3}}",
	},
};
